import { stateCity, activities, unity, stores } from '../../modules/select';
import { dateRange } from '../../modules/dateRange';

export const challengesIndex = () => {
  stateCity();
  activities();
  unity();
  stores();
  dateRange();
};
